import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../../API';
import * as Toast from "../../../components/shared/Toast";

export const getallReceiptTemplatesACTION = createAsyncThunk(
    'ReceiptTemplates/getallReceiptTemplates',
    async (data) => {
        let d = {
            device: 1,
            pageNo: -1,
            pageSize: 0,
            sortBy: 0,
            sortOrder: 0,
            filter: {
                ...data.filter
            },
        };
        return apiCall('/admin/receiptprinttemplate/getall', 'POST', d, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        return {
                            ...response.data,
                        };
                    } else {
                        Toast.error(response.data.message.message);
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject({
                    ...error,
                });
            });

    }
);
export const getReceiptTemplateACTION = createAsyncThunk(
    "ReceiptTemplates/getReceiptTemplate",
    async (data) => {
        return apiCall("/admin/receiptprinttemplate/get", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        return {
                            ...response.data,
                        };
                    } else {
                        Toast.error(response.data.message.message);
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject({
                    ...error,
                });
            });
    }
);
export const insertUpdateReceiptTemplatesAction = createAsyncThunk(
    "ReceiptTemplates/insertUpdateReceiptTemplate",
    async (data) => {
        return apiCall("/admin/receiptprinttemplate/insertupdate", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        // Toast.success(response.data.message.message);
                        return {
                            data: {
                                ...response.data,
                            },
                            message: {
                                code: response.data.message.code,
                                type: response.data.message.type,
                                message: response.data.message.message
                            },
                            newRecord: data.id ? false : true
                        };
                    } else {
                        // Toast.error(response.data.message.message);
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject({
                    ...error,
                });
            });
    }
);
export const receiptTemplatesChangeStatusACTION = createAsyncThunk(
    "ReceiptTemplates/changeStatusReceiptTemplate",
    async (data) => {
        return apiCall("/admin/receiptprinttemplate/changestatus", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        Toast.success(response.data.message.message);
                        return {
                            ...response.data,
                            id: data.id,
                        };
                    } else {
                        Toast.error(response.data.message.message);
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject({
                    ...error,
                });
            });
    }
);
export const receiptTemplatesDeleteACTION = createAsyncThunk(
    "ReceiptTemplates/deleteReceiptTemplate",
    async (data) => {
        return apiCall("/admin/receiptprinttemplate/changestatus", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        Toast.success(response.data.message.message);
                        return {
                            ...response.data,
                            data: {
                                ...data,
                            },
                        };
                    } else {
                        Toast.error(response.data.message.message);
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject({
                    ...error,
                });
            });
    }
);

export const getPrintLayoutLookupAction = createAsyncThunk(
    "ReceiptTemplates/printLayoutlookup",
    async (data) => {
        return apiCall("/restaurant/printlayout/getlookup", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        return {
                            ...response.data,
                        };
                    } else {
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error,
                });
            });
    }
);